import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import request from 'src/utils/request'

const initialState = {
  isLoading: false,
  isSuccess: false,
  maritalStatusData: [],
  error: '',
}

export const getMaritalStatusList = createAsyncThunk(
  'maritalStatus/getMaritalStatusList',
  async (_, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.student.token
      const res = await request(token).get(`/students/maritalStatus`)
      const data = await res.data
      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const maritalStatusSlice = createSlice({
  name: 'maritalStatus',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMaritalStatusList.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        }
      })
      .addCase(getMaritalStatusList.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          maritalStatusData: action.payload,
          error: '',
        }
      })
      .addCase(getMaritalStatusList.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: false,
          error: action.error.message,
        }
      })
  },
})

export default maritalStatusSlice.reducer
